import {NavigateFunction} from 'react-router-dom';

let navigateInstance = null;

export const initializeNavigate = (navigate: NavigateFunction): void => {
    navigateInstance = navigate;
};

export const getNavigate = (): NavigateFunction => navigateInstance;
